import { VehicleTableDTO } from '../../../../../Domain/DTO/VehicleTableDTO';

export class SelectVehicleHelperProps{
    VehicleList: Array<VehicleTableDTO>
    SelectedVehicle: VehicleTableDTO
}

export const InitialSelectVehicleHelperProps: SelectVehicleHelperProps = <SelectVehicleHelperProps>{ 
    VehicleList: []
};